import axios from 'axios';
import moment from "moment";
import * as Constants from "../../../constants/Constants";

export function syncWithServer(location_id) {
    return new Promise(async (resolve, reject) => {
      let payload = {
        location_id: location_id,
      }
      let tenant = localStorage.getItem("tenant")
      axios.defaults.timeout = 60000
      axios
        .post(process.env.REACT_APP_ACCESS_KEY + "/" + tenant + "/products", payload, {
          headers: {
            'Content-Type': 'application/json',
          },
        })
        .then((res) => {
          resolve(res)
        })
        .catch((error) => {
          reject(error)
        })
    })
}

export function getAllLocations() {
    let date = moment().format("YYYY-MM-DD");
    let weekday = [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
    ][new Date().getDay()];
    let payload = {
        todays_date: date,
        todays_day: weekday,
    };
    return new Promise(async (resolve, reject) => {
        let route_name = window.location.hash.substring(
            window.location.hash.substring(1).indexOf("/") + 1
        );
        let route = window.location.hash.split("/");
        let tenantName = route[1] || (
            localStorage.getItem("tenant") !== null && 
            localStorage.getItem("tenant") !== undefined && 
            localStorage.getItem("tenant") !== "" 
            ? localStorage.getItem("tenant") 
            : ""
        );
        // if (
        //     route_name !== `/${tenantName}`+"/category" &&
        //     route_name !== `/${tenantName}`+"/products" &&
        //     route_name !== `/${tenantName}`+"/rewardcard" &&
        //     route_name !== `/${tenantName}`+"/api/v1/create-online-order" &&
        //     route_name !== `/${tenantName}`+"/get-user-online-order-history" &&
        //     tenantName !== ""
        // ) {
        let url =
            process.env.REACT_APP_ACCESS_KEY +
            "/" +
            tenantName +
            "/get-location-details";
        axios
        .post(url, payload, {
            headers: {
                "Content-Type": "application/json",
            },
        })
        .then((res) => {
            resolve(res);
        })
        .catch((error) => {
            let errorData = {
                error: true,
                response: error.response,
                code: error.code,
            };
            resolve(errorData);
        });
    });
}

export function saveDeliveryAddressForFutureOrder(addressObj) {
    return new Promise(async (resolve, reject) => {
        let payload = {
            address: addressObj.address,
            city: addressObj.city,
            state: addressObj.state,
            zipcode: addressObj.postal_code,
            country: addressObj.country,
            is_default: addressObj.is_default,
            place_id: addressObj.place_id
        }
        let token = localStorage.getItem("token");
        let tenant = localStorage.getItem("tenant")
        axios.defaults.timeout = 60000
        axios.post(process.env.REACT_APP_ACCESS_KEY + "/" + tenant + Constants.SAVE_DELIVERY_ADDRESS_FOR_FUTURE_ORDER_API_ROUTE, payload, {
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + token
            },
        })
        .then((res) => {
            resolve(res)
        })
        .catch((error) => {
            let errorData = {
                error: true,
                response: error.response,
                code: error.code,
            };
            resolve(errorData);
        })
    })
}

export function getUserDeliveryAddresses() {
    return new Promise(async (resolve, reject) => {
        let token = localStorage.getItem("token");
        let tenant = localStorage.getItem("tenant")
        axios.defaults.timeout = 60000
        axios.get(process.env.REACT_APP_ACCESS_KEY + "/" + tenant + Constants.GET_USER_DELIVERY_ADDRESSES_API_ROUTE, {
            headers: {
                "Authorization": "Bearer " + token
            },
        })
        .then((res) => {
            resolve(res)
        })
        .catch((error) => {
            let errorData = {
                error: true,
                response: error.response,
                code: error.code,
            };
            reject(errorData);
        })
    })
}